import React from "react";
import { CssBaseline, Stack } from "@mui/material";
import "../css/Morquee.css";
import MiddleContent from "./MiddleContent";
import EventTabs from "./eventComponent/EventTabs/EventTabs";
import Navbar from "../redesign/components/Navbar";
import Footer from "../redesign/components/Footer";

const Dashboard = () => {
  return (
    <div style={{ width: "100%" }}>
      <CssBaseline />
      <Navbar />
      <EventTabs />
      <MiddleContent params={"dashboard"} />
     <Footer />
    </div>
  );
};

export default Dashboard;
